(function () {
  'use strict';

  angular
    .module('uepCalc', [
      'ngAnimate',
      'ngCookies',
      'ngMessages',
      'ui.router',
      'ngMaterial',
      'angulartics',
      'ngAria',
      'ngSanitize',
      'angulartics.google.analytics']);

})();

(function () {
  'use strict';

  angular
    .module('uepCalc')
    .directive('uepSubjectCard', UepSubjectCard);

  /** @ngInject */
  function UepSubjectCardController($scope, IB_SCORES) {
    var vm = this;

    vm.levels = [];

    vm.subjects = [];

    vm.isTechnician = false;

    vm.hasTechnicianSubject = true;

    vm.isIb = false;

    vm.ibScores = IB_SCORES;

    vm.getInitialSubjectValue = function () {
      if ($scope.subjectGroup.subjects.length === 1) {
        $scope.resultsModel.subject = 'Matematyka';
      }
    }

    vm.removeQualification = function (index) {
      if ($scope.resultsModel.qualifications.length > 1) {
        $scope.resultsModel.qualifications.splice(index, 1);
      }
    }

    vm.addQualification = function () {
      $scope.resultsModel.qualifications.push({score: 0});
    }

    $scope.$watch('resultsModel.subject', function (newValue, oldValue) {
      if (newValue !== oldValue) {
        if (isTechnician()) {
          vm.isTechnician = true;
          $scope.resultsModel.qualifications = [{score: 0}];
        } else {
          vm.isTechnician = false;
          $scope.resultsModel.qualifications = [];
        }
      }
    });

    function isIb() {
      return $scope.model.examType === 'ib';
    }

    function hasTechnicianSubject() {
      return vm.subjects.some(function (subject) {
        return subject.startsWith('Technik')
      });
    }

    function isTechnician() {
      return $scope.resultsModel.subject && $scope.resultsModel.subject.startsWith('Technik');
    }

    function isSubjectALanguage() {
      return $scope.subjectGroup && $scope.subjectGroup.isLanguage === true;
    }

    function createValueLabel(value, label) {
      return {value: value, label: label};
    }

    function populateLevels() {
      var list = [];
      if (vm.isIb) {
        list.push(createValueLabel('basic', 'Standard'));
        list.push(createValueLabel('extended', 'Higher'));
      } else {
        list.push(createValueLabel('basic', 'Poziom podstawowy'));
        list.push(createValueLabel('extended', 'Poziom rozszerzony'));
        if (isSubjectALanguage()) {
          list.push(createValueLabel('bilang', 'Klasa dwujęzyczna'));
        }
      }
      return list;
    }

    function populateSubjects() {
      return $scope.subjectGroup.subjects
        .filter(function (value) {
          if (vm.isIb) {
            return !value.startsWith('Technik');
          }
          return true;
        });
    }

    (function () {
      vm.isIb = isIb();
      vm.subjects = populateSubjects();
      vm.hasTechnicianSubject = hasTechnicianSubject();
      vm.levels = populateLevels();
    })();
  }

  /** @ngInject */
  function UepSubjectCard() {
    return {
      restrict: 'E',
      scope: {
        subjectGroup: '=',
        resultsModel: '=',
        model: '=',
        resultsNamePrefix: '@'
      },
      templateUrl: 'app/components/subjectCard/subjectCard.html',
      controller: UepSubjectCardController,
      controllerAs: 'subjectCardCtrl'
    };
  }

})();

(function () {
  'use strict';

  angular
    .module('uepCalc')
    .directive('uepWizardButton', UepWizardButton);

  /** @ngInject */
  function UepWizardButton() {
    return {
      restrict: 'E',
      scope: {
        label: '@',
        icon: '@',
        isDisabled: '=',
        onClick: '&'
      },
      templateUrl: 'app/components/wizardButton/wizardButton.html'
    };
  }

})();

(function () {
  'use strict';

  angular
    .module('uepCalc')
    .directive('uepNavbar', UepNavbar);

  /** @ngInject */
  function UepNavbar() {
    return {
      restrict: 'E',
      templateUrl: 'app/components/navbar/navbar.html'
    };
  }

})();

(function () {
  'use strict';

  angular
    .module('uepCalc')
    .directive('uepSocialBar', UepSocialBar);

  /** @ngInject */
  function UepSocialBar() {
    return {
      restrict: 'E',
      replace: true,
      templateUrl: 'app/components/socialBar/socialBar.html'
    };
  }

})();

(function () {
  'use strict';

  angular
    .module('uepCalc')
    .directive('uepFooter', UepFooter);

  /** @ngInject */
  function UepFooter() {
    return {
      restrict: 'E',
      templateUrl: 'app/components/footer/footer.html'
    };
  }

})();

(function () {
  'use strict';

  angular
    .module('uepCalc')
    .factory('FacultyService', FacultyService);

  /** @ngInject */
  function FacultyService($http, $log, _) {
    var api = {},
      $promise;

    api.list = function () {
      return $promise.then(function (response) {
        _.each(response.data, function (item) {
          item.eligibleSubjectGroups = [
            {groupName: 'Wybierz przedmiot 1', subjects: item.acf.eligibleSubject1}
          ];

          if (!item.acf.eligibleSubject2.includes('-')) {
            item.eligibleSubjectGroups.push({groupName: 'Wybierz przedmiot 2', subjects: item.acf.eligibleSubject2});
          }

          item.eligibleSubjectGroups.push({
            groupName: 'Wybierz język nowożytny',
            subjects: item.acf.eligibleSubjectLanguage,
            isLanguage: true
          });
        });
        return response;
      });
    };

    api.get = function (id) {
      return $promise.then(function (data) {
        return _.find(data.faculties, {id: id});
      }, handleError);
    };

    api.listFieldsOfStudies = function () {
      return api.list()
        .then(function (response) {
          return response.data;
        }, handleError);
    };

    api.getFieldsOfStudy = function (id) {
      return api.listFieldsOfStudies()
        .then(function (fieldsOfStudies) {
          return _.find(fieldsOfStudies, {id: id});
        }, handleError);
    };

    (function () {
      $promise = $http.get('/wp-json/wp/v2/fieldOfStudies?per_page=100');
    })();

    function handleError() {
      $log.error('Failed to fetch faculties');
    }

    return api;
  }

})();

(function () {
  'use strict';

  angular
    .module('uepCalc')
    .factory('calculator', Calculator);

  /** @ngInject */
  function Calculator(_) {
    return function (subjects) {
      var total = 0;

      _.each(subjects, function (subject) {
        if (isTechSchool(subject)) {
          total += calculateTechSchool(subject);
        } else {
          total += calculateHighSchool(subject);
        }
      });
      return total;
    };

    function calculateHighSchool(subject) {
      var subTotal = 0;
      if (subject.score >= 30) {
        subTotal = subject.score;
        if (subject.level === 'extended') {
          subTotal += 100;
        } else if (subject.level === 'bilang') {
          subTotal = subTotal * 1.4 + 100;
        } else {
          subTotal += 40;
        }

        subTotal = (subTotal / 2);
        if (subTotal > 100) {
          subTotal = 100;
        }
      }
      return subTotal;
    }

    function calculateTechSchool(subject) {
      var subTotal = subject.qualifications
        .reduce(function (acc, a) {
          return acc + a.score
        }, 0);

      var avg = subTotal / subject.qualifications.length;
      // if (avg < 50) {
      //   return 0;
      // }
      subTotal = (avg + 100) / 2;
      return subTotal;
    }

    function isTechSchool(subject) {
      return subject.subject && subject.subject.indexOf('Technik') === 0;
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('uepCalc')
    .factory('analyticsTracker', AnalyticsTracker);

  /** @ngInject */
  function AnalyticsTracker($analytics, _) {
    var api = {};

    function getRange(value) {
      var range = Math.floor(value / 10) * 10;
      return range + '-' + (range + 10);
    }

    api.trackWizardStepChanged = function (step) {
      $analytics.eventTrack('trackWizardStepChanged', {category: 'wizard', label: step, value: step});
    };

    api.trackWizardRestart = function () {
      $analytics.eventTrack('trackWizardRestart', {category: 'wizard', label: 'restarted'});
    };

    api.trackExamType = function (examType) {
      $analytics.eventTrack('trackExamType', {category: 'wizard', label: examType});
    };

    api.trackFieldOfStudy = function (fieldOfStudy) {
      if (fieldOfStudy) {
        $analytics.eventTrack('trackFieldOfStudy', {category: 'wizard', label: fieldOfStudy.name});
      }
    };

    api.trackResults = function (results) {
      var subjectLabel;
      _.each(results, function (item) {
        subjectLabel = item.subject + ':' + (item.extended ? 'extended' : 'basic') + ':' + getRange(item.score);
        $analytics.eventTrack('trackResults', {category: 'calculate', label: subjectLabel});
      });
    };

    api.trackScore = function (score) {
      $analytics.eventTrack('trackScore', {category: 'calculate', label: getRange(score), value: score});
    };

    return api;
  }

})();

(function () {
  'use strict';

  angular
    .module('uepCalc')
    .controller('MainController', MainController);

  /** @ngInject */
  function MainController($scope, $window, $mdDialog, FacultyService, calculator, analyticsTracker, _) {
    var vm = this;

    vm.wizardStep = 0;

    vm.fieldsOfStudies = [];

    vm.fieldsOfStudiesSuggestions = [];

    vm.model = {
      results: []
    };

    vm.nextStep = function () {
      if (vm.wizardStep < 2) {
        vm.wizardStep += 1;
        $window.scrollTo(0, 0);
      } else if (vm.wizardStep === 2) {
        vm.wizardStep += 1;
        calculate();
      }
      analyticsTracker.trackWizardStepChanged(vm.wizardStep);
    };

    vm.restart = function () {
      vm.wizardStep = 0;
      vm.model = {
        results: []
      };
      analyticsTracker.trackWizardRestart();
      vm.tab2Form.$setPristine();
    };

    $scope.$watch('mainCtrl.model.examType', function (newValue, oldValue) {
      if (newValue !== oldValue) {
        vm.model.fieldOfStudy = null;
        vm.model.results = [];
        vm.model.score = null;
        analyticsTracker.trackExamType(newValue);
      }
    });

    $scope.$watch('mainCtrl.model.fieldOfStudy', function (newValue, oldValue) {
      if (newValue !== oldValue) {
        // TODO consider a change here so that we init results with model.fieldOfStudy.eligibleSubjectGroups.length
        vm.model.results = [{}, {}, {}];
        vm.model.score = null;
        analyticsTracker.trackFieldOfStudy(newValue);
      }
    });

    function calculate() {
      vm.model.score = calculator(vm.model.results);
      populateSuggestions();
      analyticsTracker.trackScore(vm.model.score);
      analyticsTracker.trackResults(vm.model.results);
    }

    function populateSuggestions() {
      var mySubjects = [],
        flattenFields = [],
        subjects;

      _.each(vm.fieldsOfStudies, function (field) {
        subjects = [];
        _.each(field.eligibleSubjectGroups, function (group) {
          subjects = _.concat(subjects, group.subjects);
        });

        flattenFields.push({
          name: field.name,
          subjects: subjects,
          minSubjects: field.eligibleSubjectGroups.length
        });
      });

      _.each(vm.model.results, function (item) {
        mySubjects.push(item.subject);
      });

      vm.fieldsOfStudiesSuggestions = _.filter(flattenFields, function (field) {
        return _.intersection(field.subjects, mySubjects).length === mySubjects.length
          && mySubjects.length >= field.minSubjects
          && field.name !== vm.model.fieldOfStudy.name;
      });
    }

    (function () {
      FacultyService.listFieldsOfStudies()
        .then(function (fieldsOfStudies) {
          vm.fieldsOfStudies = fieldsOfStudies;
        });
    })();
  }
})();

(function() {
  'use strict';

  angular
    .module('uepCalc')
    .run(runBlock);

  /** @ngInject */
  function runBlock() {
  }

})();

(function () {
  'use strict';

  angular
    .module('uepCalc')
    .config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider, $urlRouterProvider) {
    $stateProvider
      .state('home', {
        url: '/',
        templateUrl: 'app/main/main.html',
        controller: 'MainController',
        controllerAs: 'mainCtrl'
      });

    $urlRouterProvider.otherwise('/');
  }

})();

/* global _:false */
(function () {
  'use strict';

  angular
    .module('uepCalc')
    .constant('_', _)
    .constant('IB_SCORES', [
      {label: 'Excelent', value: 100},
      {label: 'Very Good', value: 90},
      {label: 'Good', value: 80},
      {label: 'Satisfactory', value: 60},
      {label: 'Mediocre', value: 40},
      {label: 'Poor', value: 30},
      {label: 'Nie Zaliczone', value: 0}
    ]);
})();

(function () {
  'use strict';

  angular
    .module('uepCalc')
    .config(config);

  /** @ngInject */
  function config($logProvider, $mdThemingProvider, $analyticsProvider) {
    // Enable log
    $logProvider.debugEnabled(true);
    $analyticsProvider.firstPageview(true);

    configTheme($mdThemingProvider);
  }

  function configTheme($mdThemingProvider) {
    //generated by https://angular-md-color.com/#/
    var customPrimary = {
      '50': '#0ccc6b',
      '100': '#0bb45e',
      '200': '#099c52',
      '300': '#088445',
      '400': '#066c39',
      '500': '#05542C',
      '600': '#043c1f',
      '700': '#022413',
      '800': '#010c06',
      '900': '#000000',
      'A100': '#0ee478',
      'A200': '#1af184',
      'A400': '#32f391',
      'A700': '#000000',
      'contrastDefaultColor': 'light'
    };
    $mdThemingProvider
      .definePalette('customPrimary',
        customPrimary);

    var customAccent = {
      '50': '#b3b3b3',
      '100': '#bfbfbf',
      '200': '#cccccc',
      '300': '#d9d9d9',
      '400': '#e6e6e6',
      '500': '#f2f2f2',
      '600': '#ffffff',
      '700': '#ffffff',
      '800': '#ffffff',
      '900': '#ffffff',
      'A100': '#05542C',
      'A200': '#05542C',
      'A400': '#f2f2f2',
      'A700': '#ffffff',
      'contrastDefaultColor': 'light'
    };
    $mdThemingProvider
      .definePalette('customAccent',
        customAccent);

    $mdThemingProvider.theme('default')
      .primaryPalette('customPrimary')
      .accentPalette('customAccent');
  }

})();

angular.module("uepCalc").run(["$templateCache", function($templateCache) {$templateCache.put("app/main/_tab.1.html","<h1 class=\"md-title text-center\" layout=\"row\" data-layout-align=\"center center\">Jakiego rodzaju egzamin zdajesz?</h1><form name=\"tab1Form\"><div id=\"examType\" layout=\"column\" data-flex=\"100\"><md-radio-group ng-model=\"mainCtrl.model.examType\" ng-required=\"true\" layout=\"column\" layout-align=\"space-around start\" layout-gt-xs=\"row\" layout-align-gt-xs=\"space-around center\"><md-radio-button value=\"nowa-matura\" aria-label=\"Nowa matura\">Nowa matura</md-radio-button><md-radio-button value=\"ib\" aria-label=\"International Baccalaureate\">International Baccalaureate (IB)</md-radio-button></md-radio-group></div><div data-layout=\"column\" data-layout-align=\"center center\"><uep-wizard-button on-click=\"mainCtrl.nextStep()\" is-disabled=\"!(tab1Form.$valid && tab1Form.$dirty)\"></uep-wizard-button></div></form>");
$templateCache.put("app/main/_tab.2.html","<h1 class=\"md-title\" layout=\"row\" data-layout-align=\"center center\">Na jakim kierunku chcesz studiować?</h1><form name=\"mainCtrl.tab2Form\"><md-input-container id=\"fieldOfStudy\" class=\"md-block\"><label>Wybierz kierunek studiów</label><md-select ng-model=\"mainCtrl.model.fieldOfStudy\" aria-label=\"Wybierz kierunek studiów\" name=\"fieldOfStudy\" required=\"\"><md-option ng-repeat=\"field in mainCtrl.fieldsOfStudies | orderBy:\'title.rendered\'\" aria-label=\"{{field.title.rendered}}\" ng-value=\"field\">{{field.title.rendered}}</md-option></md-select><div ng-messages=\"tab2Form.fieldOfStudy.$error\" role=\"alert\"><div ng-message=\"required\">To pole jest wymagane.</div></div><div ng-show=\"mainCtrl.model.fieldOfStudy\" class=\"fade\"><h2>{{mainCtrl.model.fieldOfStudy.title.rendered}}</h2><p ng-bind-html=\"mainCtrl.model.fieldOfStudy.content.rendered\"></p></div></md-input-container></form><div data-layout=\"column\" data-layout-align=\"center center\"><uep-wizard-button data-on-click=\"mainCtrl.nextStep()\" data-is-disabled=\"!(mainCtrl.tab2Form.$valid && mainCtrl.tab2Form.$dirty)\"></uep-wizard-button></div>");
$templateCache.put("app/main/_tab.3.html","<form name=\"tab3Form\"><uep-subject-card ng-repeat=\"subjectGroup in mainCtrl.model.fieldOfStudy.eligibleSubjectGroups\" subject-group=\"subjectGroup\" model=\"mainCtrl.model\" results-model=\"mainCtrl.model.results[$index]\" results-name-prefix=\"result[{{$index}}]\"></uep-subject-card><div data-layout=\"column\" data-layout-align=\"center center\"><uep-wizard-button data-on-click=\"mainCtrl.nextStep()\" data-is-disabled=\"!(tab3Form.$valid && tab3Form.$dirty)\"></uep-wizard-button></div></form>");
$templateCache.put("app/main/_tab.4.html","<div data-layout=\"column\" data-layout-align=\"center center\"><h3 class=\"md-headline\">Suma Twoich punktów rankingowych wynosi</h3><h2 class=\"md-display-3\"><strong>{{mainCtrl.model.score | number : 2}}</strong></h2><p ng-if=\"mainCtrl.model.fieldOfStudy.acf.previousScoreLimit\">Limit punktowy z ubiegłego roku na wybrany kierunek <strong>{{mainCtrl.model.fieldOfStudy.title.rendered}}</strong> wynosił</p><h3 class=\"md-display-1\" ng-if=\"mainCtrl.model.fieldOfStudy.acf.previousScoreLimit\"><strong>{{mainCtrl.model.fieldOfStudy.acf.previousScoreLimit | number : 2}}</strong></h3><div><p data-ng-show=\"mainCtrl.fieldsOfStudiesSuggestions.length > 0\">Z wybranymi przedmiotami możesz startować również na:</p><ul><li data-ng-repeat=\"field in mainCtrl.fieldsOfStudiesSuggestions | orderBy:\'name\'\">{{field.name}}</li></ul></div><div layout=\"row\"><uep-wizard-button data-on-click=\"mainCtrl.restart()\" data-label=\"Restart\" data-icon=\"replay\"></uep-wizard-button></div></div>");
$templateCache.put("app/main/main.html","<div id=\"main\" layout=\"column\" layout-padding=\"\"><md-tabs md-dynamic-height=\"\" md-selected=\"mainCtrl.wizardStep\" md-border-bottom=\"\" md-swipe-content=\"false\" md-no-pagination=\"true\" md-stretch-tabs=\"always\"><md-tab label=\"1. Egzamin\" data-ng-disabled=\"mainCtrl.wizardStep < 0\"><md-content data-ng-include=\"\'app/main/_tab.1.html\'\"></md-content></md-tab><md-tab label=\"2. Kierunek\" data-ng-disabled=\"mainCtrl.wizardStep < 1\"><md-content data-ng-include=\"\'app/main/_tab.2.html\'\"></md-content></md-tab><md-tab label=\"3. Wyniki\" data-ng-disabled=\"mainCtrl.wizardStep < 2\"><md-content data-ng-include=\"\'app/main/_tab.3.html\'\"></md-content></md-tab><md-tab label=\"4. Punkty\" data-ng-disabled=\"mainCtrl.wizardStep < 3\"><md-content data-ng-include=\"\'app/main/_tab.4.html\'\"></md-content></md-tab></md-tabs></div>");
$templateCache.put("app/components/footer/footer.html","<md-toolbar id=\"footer\"><div class=\"md-toolbar-tools\" layout=\"row\" data-layout-padding=\"\" data-flex=\"100\" data-flex-gt-sm=\"80\" data-flex-gt-md=\"60\" data-flex-offset-gt-sm=\"10\" data-flex-offset-gt-md=\"20\" data-layout-align=\"space-between center\"><span hide-xs=\"\" class=\"contact-us\"><strong>Masz pytania?</strong><br>Skontaktuj się z nami!</span><div class=\"address\"><span><md-tooltip md-direction=\"top\">Zadzwoń do nas</md-tooltip><strong>nr tel.:</strong> <a href=\"tel:+48618569190\">+48 61 856 91 90</a>, <a href=\"tel:+48618569188\">+48 61 856 91 88</a></span></div><div class=\"address\"><span><md-tooltip md-direction=\"top\">Napisz do nas</md-tooltip><strong>e-mail:</strong> <a href=\"mailto:rekrutacja@ue.poznan.pl\">rekrutacja@ue.poznan.pl</a></span><br><span><md-tooltip md-direction=\"top\">Odwiedź naszą stronę</md-tooltip><strong>WWW:</strong> <a href=\"http://rekrutacja.ue.poznan.pl\" target=\"_blank\">rekrutacja.ue.poznan.pl</a></span></div></div></md-toolbar>");
$templateCache.put("app/components/navbar/navbar.html","<md-toolbar><div class=\"md-toolbar-tools\" layout=\"row\" data-flex=\"100\" data-flex-gt-sm=\"80\" data-flex-gt-md=\"60\" data-flex-offset-gt-sm=\"10\" data-flex-offset-gt-md=\"20\" data-layout-align=\"space-between center\"><a data-ui-sref=\"home\" class=\"brand\"><h1><md-icon>calculate</md-icon>Kalkulator Maturzysty</h1></a> <a href=\"http://rekrutacja.ue.poznan.pl/\" target=\"_blank\" layout=\"row\" class=\"uep-logo\" data-layout-align=\"end center\"><md-tooltip md-direction=\"left\">Wróć na stronę główną rekrutacja UEP</md-tooltip><img src=\"/assets/images/logo.png\" alt=\"Uniwersytet Ekonomiczny w Poznaniu\"></a></div></md-toolbar>");
$templateCache.put("app/components/socialBar/socialBar.html","<div class=\"social-bar\"><a href=\"https://www.facebook.com/uepoznan\" class=\"fb-icon\" title=\"Profil Facebook\" tabindex=\"-1\" target=\"_blank\"></a> <a href=\"https://x.com/UEwP\" class=\"x-icon\" title=\"Profil X\" tabindex=\"-1\" target=\"_blank\"></a> <a href=\"http://instagram.com/uepoznan\" class=\"in-icon\" title=\"Profil Instagram\" tabindex=\"-1\" target=\"_blank\"></a> <a href=\"http://www.linkedin.com/edu/school?id=15905&amp;trk=tyah&amp;trkInfo=tas%3Auniwersytet%20Ekonomiczny%20w%20Poznaniu%2Cidx%3A2-1-2\" class=\"ln-icon\" title=\"Profil LinkedIn\" tabindex=\"-1\" target=\"_blank\"></a> <a href=\"https://www.youtube.com/user/uepoznan\" class=\"yt-icon\" title=\"Profil Youtube\" tabindex=\"-1\" target=\"_blank\"></a></div>");
$templateCache.put("app/components/wizardButton/wizardButton.html","<md-button class=\"md-fab md-primary fade uep-wizard-button\" data-ng-click=\"onClick()\" data-ng-disabled=\"isDisabled\" aria-label=\"{{label || \'Dalej\'}}\"><md-tooltip>{{label || \'Dalej\'}}</md-tooltip><md-icon>{{icon || \'arrow_forward\'}}</md-icon></md-button>");
$templateCache.put("app/components/subjectCard/subjectCard.html","<md-card data-layout=\"column\" data-layout-gt-sm=\"row\" data-layout-align=\"space-between stretch\"><md-card-content flex=\"\"><md-input-container class=\"md-block\" data-flex=\"100\"><label>{{subjectGroup.groupName}}</label><md-select ng-model=\"resultsModel.subject\" ng-init=\"subjectCardCtrl.getInitialSubjectValue()\" name=\"{{resultsNamePrefix}}.subject\" data-required=\"\"><md-option ng-repeat=\"subject in subjectCardCtrl.subjects | orderBy:name\" ng-value=\"subject\">{{subject}}</md-option></md-select><div ng-messages=\"tab3Form[\'{{resultsNamePrefix}}.subject\'].$error\" role=\"alert\"><div ng-message=\"required\">To pole jest wymagane.</div></div></md-input-container><div class=\"input-hint\" ng-if=\"subjectCardCtrl.hasTechnicianSubject\">W wypadku posiadania jednego z wykazanych w słowniku tytułów technika, kandydat może w miejsce przedmiotu kwalifikacyjnego wskazać odpowiedni tytuł i podać średnią arytmetyczną z wyników egzaminu zawodowego/egzaminu potwierdzającego kwalifikacje w zawodzie technika wskazane na dyplomie zawodowym</div><md-input-container ng-if=\"!subjectCardCtrl.isTechnician\"><md-radio-group ng-model=\"resultsModel.level\" ng-required=\"true\" name=\"{{resultsNamePrefix}}.level\" layout=\"column\" layout-align=\"space-around start\" layout-gt-xs=\"row\" layout-align-gt-xs=\"space-around center\"><md-radio-button ng-repeat=\"level in subjectCardCtrl.levels\" ng-value=\"level.value\" aria-label=\"{{level.label}}\">{{level.label}}</md-radio-button></md-radio-group></md-input-container><div ng-if=\"!subjectCardCtrl.isTechnician\"><md-slider-container ng-if=\"!subjectCardCtrl.isIb\" layout=\"\"><div flex=\"50\" flex-gt-sm=\"20\" layout=\"\" layout-align=\"center center\"><span>Liczba uzyskanych punktów</span></div><md-slider name=\"{{resultsNamePrefix}}.score\" flex=\"70\" hide-xs=\"\" min=\"0\" max=\"100\" step=\"1\" ng-model=\"resultsModel.score\" aria-label=\"Liczba uzyskanych punktów procentowych\"></md-slider><md-input-container flex=\"50\" flex-gt-sm=\"10\"><input name=\"{{resultsNamePrefix}}.score\" type=\"number\" min=\"0\" max=\"100\" ng-model=\"resultsModel.score\" aria-label=\"Liczba uzyskanych punktów procentowych\"></md-input-container></md-slider-container><md-input-container class=\"md-block\" ng-if=\"subjectCardCtrl.isIb\" data-flex=\"100\"><label>Liczba uzyskanych punktów</label><md-select ng-model=\"resultsModel.score\" name=\"{{resultsNamePrefix}}.score\" required=\"\"><md-option ng-repeat=\"item in subjectCardCtrl.ibScores\" ng-value=\"item.value\">{{item.label}} - ({{item.value}})</md-option></md-select><div ng-messages=\"tab3Form[\'result[\' + $index + \'].score\'].$error\" role=\"alert\"><div ng-message=\"required\">To pole jest wymagane.</div></div></md-input-container><div class=\"input-hint\" ng-show=\"resultsModel.score < 30\">Nie osiągnięto minimalnego progu. Wynik nie zostanie doliczony.</div></div><div ng-if=\"subjectCardCtrl.isTechnician\"><md-slider-container ng-repeat=\"qualification in resultsModel.qualifications\" layout=\"column\" layout-gt-sm=\"row\" layout-gt-sm-align=\"space-between center\"><div flex=\"100\" flex-gt-sm=\"20\">Wynik kwalifikacji #{{$index + 1}}</div><md-slider flex-gt-sm=\"70\" hide-xs=\"\" min=\"0\" max=\"100\" step=\"1\" ng-model=\"qualification.score\" aria-label=\"Wynik kwalifikacji #{{$index}}\"></md-slider><div layout=\"row\" layout-align=\"space-between center\" flex=\"100\" data-flex-gt-sm=\"20\"><md-input-container><input name=\"{{resultsNamePrefix}}.score\" type=\"number\" min=\"0\" max=\"100\" ng-model=\"qualification.score\" aria-label=\"Wynik cząstkowy #{{$index}}\"></md-input-container><md-button flex=\"noshrink\" ng-click=\"subjectCardCtrl.removeQualification($index)\" class=\"md-icon-button md-raised md-button md-ink-ripple md-mini\" aria-label=\"Usuń wynik cząstkowy\" ng-disabled=\"resultsModel.qualifications.length === 1\"><md-tooltip>Usuń wynik cząstkowy</md-tooltip><md-icon>remove</md-icon></md-button></div></md-slider-container><div layout=\"row\" layout-align=\"space-between center\"><div class=\"input-hint\">W celu wyliczenia średniej kolejne wyniki cząstkowe dodaj używając przycisku \"+\".</div><md-button layout=\"row\" layout-align=\"end center\" class=\"md-mini md-fab md-primary md-button md-ink-ripple\" data-ng-click=\"subjectCardCtrl.addQualification()\" aria-label=\"Dodaj kwalifikacje\"><md-tooltip>Dodaj wynik kwalifikacji</md-tooltip><md-icon>add</md-icon></md-button></div></div></md-card-content></md-card>");}]);